/**
 * Adds a global click listener for elements with class .uc-show-banner.
 * This triggers the Usercentrics "Second Layer" (service settings).
 */
export default function initUsercentricsLinks() {
  document.addEventListener('click', (event) => {
    // Look for a link or button with the specific class.
    const target = event.target.closest('.uc-show-banner');
    if (target) {
      event.preventDefault();
      // Trigger Usercentrics UI.
      if (typeof window?.UC_UI?.showSecondLayer === 'function') {
        window.UC_UI.showSecondLayer();
      }
    }
  });
}
